import { Guards } from 'interfaces/guards'
import { connectLoadable } from 'helpers/loadableHelpers'
import { isSubmitting } from 'redux-form'
import { State } from 'interfaces/state'
import CreditLinkage, { CreditLinkageDispatchProps, CreditLinkageOwnProps, CreditLinkageStateProps } from 'components/features/pfm/CreditLinkage/CreditLinkage'
import { resetCreditActionCreator, retryCreditActionCreator } from 'actions/creditActions'
import { memberInfoSelector } from 'selectors/globalSelectors'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import DefaultPreloader from 'components/atoms/preloaders/DefaultPreloader'
import { isOnboardingFinishingSelector } from 'selectors/onboardingSelectors'
import { creditFormNameSelector } from 'selectors/creditSelectors'

const mapStateToProps = (state: State): CreditLinkageStateProps => {
  const member = memberInfoSelector(state)
  if (!member) {
    throw createForgottenGuardError('OnboardingCreditContainer', 'memberInfoGuard')
  }

  const { phase, error, questions, questionIndex } = state.app.creditscore.linkage
  const formName = creditFormNameSelector(state)
  const isFormSubmitting = isSubmitting(formName)(state)
  const isLinkageCompleted = member.is_creditfile_linked
  // blocked error has higher priority
  const creditFormError = isLinkageCompleted ? null : error

  const isSkipLoading = isOnboardingFinishingSelector(state)

  return {
    phase,
    isFormSubmitting,
    hasNotAnsweredQuestions: questionIndex < questions.length,
    isDisabled: isLinkageCompleted,
    error: creditFormError,
    isSkipLoading,
    isSkipped: member.onboarding_step === 'finished',
  }
}

const mapDispatchToProps: CreditLinkageDispatchProps = {
  retryCredit: retryCreditActionCreator,
  skipCredit: () => { /* do nothing */ },
  resetCredit: resetCreditActionCreator,
}

const onboardingCreditGuards: Guards = []

const Preloader = () => <DefaultPreloader isTransparent />
const CreditLinkageContainer = connectLoadable<
  CreditLinkageStateProps, CreditLinkageDispatchProps, CreditLinkageOwnProps
>(onboardingCreditGuards, Preloader)(mapStateToProps, mapDispatchToProps)(CreditLinkage)

export default CreditLinkageContainer
